import { render, staticRenderFns } from "./DisplayStoreItemsRegist.vue?vue&type=template&id=2b47ec18&"
import script from "./DisplayStoreItemsRegist.vue?vue&type=script&lang=js&"
export * from "./DisplayStoreItemsRegist.vue?vue&type=script&lang=js&"
import style0 from "./DisplayStoreItemsRegist.vue?vue&type=style&index=0&id=2b47ec18&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports